<i18n lang='yml' src='../i18n/ScheduledItem.yml'></i18n>

<template>
  <div v-if="loading">
    <loading-animation-vue></loading-animation-vue>
  </div>
  <div v-else class='tile padded'>
    <div class='form-group row'>
      <div class='col-md-3'>
        <label>{{ $t('start_date') }}</label>
        <flat-pickr :name="`${fieldName}[item_start_date]`" input-class='form-control' v-model='startDate' :config='datePickerConfig(true)'></flat-pickr>
      </div>
      <div class='col-md-3' v-show='!allDay'>
        <label>{{ $t('start_time') }}</label>
        <flat-pickr input-class='form-control' v-model='startTime' :config='timePickerConfig()'></flat-pickr>
        <input :name="`${fieldName}[item_start_time]`" type="hidden" :value="`${startDate} ${startTime} ${timezone}`">
      </div>
      <div class='col-md-3'>
        <label>{{ $t('end_date') }}</label>
        <flat-pickr :name="`${fieldName}[item_end_date]`" input-class='form-control' v-model='endDate' :config='datePickerConfig(true)'></flat-pickr>
      </div>
      <div class='col-md-3' v-show='!allDay'>
        <label>{{ $t('end_time') }}</label>
        <flat-pickr  input-class='form-control' v-model='endTime' :config='timePickerConfig()'></flat-pickr>
        <input :name="`${fieldName}[item_end_time]`" type="hidden" :value="`${endDate} ${endTime} ${timezone}`">
      </div>
    </div>

    <div class='form-group row'>
      <div class='col-md-2'>
        <label>
          <input :name="`${fieldName}[all_day]`" type="hidden" :value="false" />
          <input :name="`${fieldName}[all_day]`" type='checkbox' v-model='allDay' :checked="true">
          {{ $t('all_day') }}
        </label>
      </div>
      <div class='col-md-2'>
        <label>
          <input :name="`repeat`" type="hidden" :value="false" />
          <input name='repeat' type='checkbox' v-model='repeat'>
          {{ $t('repeat') }}
        </label>
      </div>
    </div>
    
    <template v-if='repeat'>
      <div class='row'>
        <div class='form-group col-md-3'>
          <label>{{ $t('frequency') }}</label>
          <select :name="`${fieldName}[frequency]`" class='form-control' v-model='frequency'>
            <option value='daily'>{{ $t('daily') }}</option>
            <option value='weekly'>{{ $t('weekly') }}</option>
            <option value='monthly'>{{ $t('monthly') }}</option>
            <option value='yearly'>{{ $t('yearly') }}</option>
          </select>
        </div>
        <div class='form-group col-md-3'>
          <label>{{ $t('frequency_every') }}</label>
          <div class='input-group'>
            <select :name="`${fieldName}[interval]`" class='form-control' v-model='interval'>
              <option v-for='(element, index) in 30' :key="index" :value='element'>{{ element }}</option>
            </select>
            <span class='input-group-addon'>{{ $t('count_' + frequency) }}</span>
          </div>
        </div>
      </div>
      <template v-if='frequency === "weekly"'>
        <label>{{ $t('frequency_on') }}</label>
        <div class='form-group'>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='1' v-model='frequencyWeekly'>
            {{ $t('days.mon') }}
          </label>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='2' v-model='frequencyWeekly'>
            {{ $t('days.tue') }}
          </label>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='3' v-model='frequencyWeekly'>
            {{ $t('days.wed') }}
          </label>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='4' v-model='frequencyWeekly'>
            {{ $t('days.thu') }}
          </label>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='5' v-model='frequencyWeekly'>
            {{ $t('days.fri') }}
          </label>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='6' v-model='frequencyWeekly'>
            {{ $t('days.sat') }}
          </label>
          <label class='checkbox-inline'>
            <input :name="`${fieldName}[frequency_weekly][]`" type='checkbox' value='0' v-model='frequencyWeekly'>
            {{ $t('days.sun') }}
          </label>
        </div>
      </template>
      <template v-else-if='frequency === "monthly"'>
        <label>{{ $t('frequency_by') }}</label>
        <div class='form-group'>
          <label class='radio-inline'>
            <input :name="`${fieldName}[frequency_monthly]`" type='radio' value='m' v-model='frequencyMonthly'>
            {{ $t('frequency_m.m') }}
          </label>
          <label class='radio-inline'>
            <input :name="`${fieldName}[frequency_monthly]`" type='radio' value='w' v-model='frequencyMonthly'>
            {{ $t('frequency_m.w') }}
          </label>
        </div>
      </template>
      <div class='form-group'>
        <label>{{ $t('recurrence_start_date') }}</label>
        <flat-pickr :name="`${fieldName}[recurrence_start_date]`" input-class='form-control' v-model='recurrenceStartDate' :config='recurrenceDatePickerConfig()'></flat-pickr>
      </div>
      <div class='form-group'>
        <label>{{ $t('recurrence_end_date') }}</label>
        <div class='radio'>
          <label>
            <input type='radio' :value='false' v-model='recurrenceHasEndDate'>
            <span class='form-control-static'>{{ $t('never') }}</span>
          </label>
        </div>
        <div class='radio last'>
          <label>
            <input type='radio' :value='true' v-model='recurrenceHasEndDate'>
            <div class='input-group'>
              <span class='input-group-addon'>{{ $t('on') }}</span>
              <flat-pickr v-show='recurrenceHasEndDate' :name="`${fieldName}[recurrence_end_date]`" input-class='form-control' v-model='recurrenceEndDate' :config='recurrenceDatePickerConfig(true)'></flat-pickr>
              <input v-if='!recurrenceHasEndDate' :name="`${fieldName}[recurrence_end_date]`" :value='null' class='form-control'>
            </div>
          </label>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
    export default {
        props: {
            locale: { type: String },
            item: { type: Object },
            fieldName: { type: String }
        },
        data () {
            const defaultDate = new Date();
            defaultDate.setHours(0, 0, 0, 0);
            const defaultStartTime = new Date();
            defaultStartTime.setMinutes(0, 0, 0);
            const defaultEndTime = new Date();
            defaultEndTime.setHours(defaultStartTime.getHours() + 1, 0, 0, 0);
            return {
                loading: true,
                defaultDate: defaultDate,
                startDate: this.parseInputDate(this.item.item_start_date, defaultDate),
                startTime: this.parseInputTime(this.item.item_start_time, defaultStartTime),
                endDate: this.parseInputDate(this.item.item_end_date, defaultDate),
                endTime: this.parseInputTime(this.item.item_end_time, defaultEndTime),
                recurrenceStartDate: this.parseInputDate(this.item.recurrence_start_date || this.item.item_start_date, defaultDate),
                recurrenceEndDate: this.parseInputDate(this.item.recurrence_end_date),
                allDay: this.item.all_day,
                repeat: !!this.item.frequency && !!this.item.interval,
                frequency: this.item.frequency || 'daily',
                frequencyWeekly: this.item.frequency_weekly || [],
                frequencyMonthly: this.item.frequency_monthly || 'm',
                interval: this.item.interval || 1,
                timezone: new Date().getTimezoneOffset() / 60,
                recurrenceHasEndDate: !!this.item.recurrence_end_date
            }
        },
        mounted () {
            this.$i18n.locale = this.locale;
            this.loading = false;
        },
        methods: {
            parseInputDate: function (date, fallback = null) {
                if (date === null) {
                    if (fallback === null) {
                        return fallback;
                    }

                    const year = fallback.getFullYear();
                    const month = ('0' + (fallback.getMonth() + 1)).slice(-2);
                    const day = ('0' + fallback.getDate()).slice(-2);
                    return year + '-' + month + '-' + day;
                }

                const dateObj = new Date(date);
                const parsedDate = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
                const year = parsedDate.getFullYear();
                const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2);
                const day = ('0' + parsedDate.getDate()).slice(-2);
                return year + '-' + month + '-' + day;
            },
            parseInputTime: function (date, fallback = null) {
                if (date === null) {
                    if (fallback === null) {
                        return fallback;
                    }
                    return fallback.getHours() + ':' + fallback.getMinutes();
                }

                const dateObj = new Date(date);
                return dateObj.getHours() + ':' + dateObj.getMinutes();
            },
            datePickerConfig: function (end = false) {
                if (end) {
                    return { minDate: this.parseInputDate(this.startDate, this.defaultDate) };
                } else {
                    return { minDate: this.parseInputDate(this.defaultDate) };
                }
            },
            timePickerConfig: function () {
                return {
                    enableTime: true,
                    minuteIncrement: 30,
                    noCalendar: true,
                    time_24hr: true
                };
            },
            recurrenceDatePickerConfig: function (end = false) {
                if (end && this.recurrenceStartDate) {
                    return { minDate: this.parseInputDate(this.recurrenceStartDate, this.defaultDate) };
                } else {
                    return { minDate: this.parseInputDate(this.startDate, this.defaultDate) };
                }
            }
        }
    }
</script>
